import { Routes } from '@angular/router';

import { adminGuard } from '../../core/auth/admin.guard';

export const portalRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../../layout/app-shell/app-shell.component').then(
        (module) => module.AppShellComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      // Gestión
      {
        path: 'vinedos',
        loadComponent: () =>
          import('./pages/produccion/produccion-page.component').then(
            (module) => module.ProduccionPageComponent
          ),
        data: {
          title: 'Viñedos',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'vinedos/nueva-revision/:registro',
        loadComponent: () =>
          import('./pages/solicitudes/nueva-solicitud-revision/nueva-solicitud-revision-page.component').then(
            (module) => module.NuevaSolicitudRevisionPageComponent
          ),
        data: {
          title: 'Nueva solicitud de revisión',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'vinedos/:registro',
        loadComponent: () =>
          import('./pages/produccion/parcela-detalle/parcela-detalle-page.component').then(
            (module) => module.ParcelaDetallePageComponent
          ),
        data: {
          title: 'Detalle de parcela',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'documentacion',
        loadComponent: () =>
          import('./pages/documentacion/documentacion-page.component').then(
            (module) => module.DocumentacionPageComponent
          ),
        data: {
          title: 'Documentación',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'documentacion/:id',
        loadComponent: () =>
          import('./pages/documentacion/documentacion-detalle/documentacion-detalle-page.component').then(
            (module) => module.DocumentacionDetallePageComponent
          ),
        data: {
          title: 'Detalle documento',
          eyebrow: 'Portal del Viticultor',
        },
      },
      // Operative
      {
        path: 'comunicaciones',
        loadComponent: () =>
          import('./pages/comunicaciones/comunicaciones-page.component').then(
            (module) => module.ComunicacionesPageComponent
          ),
        data: {
          title: 'Comunicaciones',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'comunicaciones/nueva',
        canActivate: [adminGuard],
        loadComponent: () =>
          import(
            './pages/comunicaciones/nueva-comunicacion/nueva-comunicacion-page.component'
          ).then((module) => module.NuevaComunicacionPageComponent),
        data: {
          title: 'Nueva comunicación',
          eyebrow: 'Administración',
        },
      },
      {
        path: 'comunicaciones/:id',
        loadComponent: () =>
          import('./pages/comunicaciones/comunicacion-detalle/comunicacion-detalle-page.component').then(
            (module) => module.ComunicacionDetallePageComponent
          ),
        data: {
          title: 'Detalle de comunicación',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'solicitudes',
        loadComponent: () =>
          import('./pages/solicitudes/solicitudes-page.component').then(
            (module) => module.SolicitudesPageComponent
          ),
        data: {
          title: 'Solicitudes',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'solicitudes/nueva-revision',
        loadComponent: () =>
          import('./pages/solicitudes/nueva-solicitud-revision/nueva-solicitud-revision-page.component').then(
            (module) => module.NuevaSolicitudRevisionPageComponent
          ),
        data: {
          title: 'Nueva solicitud de revisión',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'solicitudes/nueva-revision/:registro',
        loadComponent: () =>
          import('./pages/solicitudes/nueva-solicitud-revision/nueva-solicitud-revision-page.component').then(
            (module) => module.NuevaSolicitudRevisionPageComponent
          ),
        data: {
          title: 'Nueva solicitud de revisión',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'solicitudes/:reference',
        loadComponent: () =>
          import('./pages/solicitudes/solicitud-detalle/solicitud-detalle-page.component').then(
            (module) => module.SolicitudDetallePageComponent
          ),
        data: {
          title: 'Detalle de solicitud',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'reclamaciones',
        loadComponent: () =>
          import('./pages/reclamaciones/reclamaciones-page.component').then(
            (module) => module.ReclamacionesPageComponent
          ),
        data: {
          title: 'Reclamaciones e incidencias',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'reclamaciones/nueva/:registro',
        loadComponent: () =>
          import('./pages/reclamaciones/nueva-reclamacion/nueva-reclamacion-page.component').then(
            (module) => module.NuevaReclamacionPageComponent
          ),
        data: {
          title: 'Nueva reclamación',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'reclamaciones/:reference',
        loadComponent: () =>
          import('./pages/reclamaciones/reclamacion-detalle/reclamacion-detalle-page.component').then(
            (module) => module.ReclamacionDetallePageComponent
          ),
        data: {
          title: 'Detalle de incidencia',
          eyebrow: 'Portal del Viticultor',
        },
      },
      // Usuarios
      {
        path: 'viticultores',
        loadComponent: () =>
          import('./pages/viticultores/viticultores-page.component').then(
            (module) => module.ViticultoresPageComponent
          ),
        data: {
          title: 'Usuarios viticultores',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'administradores',
        loadComponent: () =>
          import('./pages/user-admin/user-admin-page.component').then(
            (module) => module.UserAdminPageComponent
          ),
        data: {
          title: 'Administradores',
          eyebrow: 'Portal del Viticultor',
        },
      },
      {
        path: 'configuracion',
        loadComponent: () =>
          import('./pages/configuracion/configuracion-page.component').then(
            (module) => module.ConfiguracionPageComponent
          ),
        data: {
          title: 'Configuración',
          eyebrow: 'Administrador',
        },
      },
      {
        path: 'configuracion/fecha-parcelario',
        loadComponent: () =>
          import('./pages/configuracion/fecha-parcelario/fecha-parcelario-page.component').then(
            (module) => module.FechaParcelarioPageComponent
          ),
        data: {
          title: 'Fecha de datos del parcelario',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'configuracion/contacto',
        loadComponent: () =>
          import('./pages/configuracion/contacto/contacto-page.component').then(
            (module) => module.ContactoPageComponent
          ),
        data: {
          title: 'Contacto del Consejo Regulador',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'campanas',
        loadComponent: () =>
          import('./pages/campanas/campanas-list-page/campanas-list-page.component').then(
            (module) => module.CampanasListPageComponent
          ),
        data: {
          title: 'Campañas activas',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'campanas/:id',
        loadComponent: () =>
          import('./pages/campanas/campanas-page.component').then(
            (module) => module.CampanasPageComponent
          ),
        data: {
          title: 'Detalle de campaña',
          eyebrow: 'Campañas activas',
        },
      },
      {
        path: 'grupos-segmentacion',
        loadComponent: () =>
          import('./pages/grupos-segmentacion/grupos-segmentacion-page.component').then(
            (module) => module.GruposSegmentacionPageComponent
          ),
        data: {
          title: 'Grupos y segmentación',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'mi-cuenta',
        redirectTo: 'mi-perfil',
        pathMatch: 'full',
      },
      {
        path: 'mi-perfil',
        loadComponent: () =>
          import('./pages/mi-perfil/mi-perfil-page.component').then(
            (module) => module.MiPerfilPageComponent
          ),
        data: {
          title: 'Mi perfil',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'ayuda',
        loadComponent: () =>
          import('./pages/ayuda-contacto/ayuda-contacto-page.component').then(
            (module) => module.AyudaContactoPageComponent
          ),
        data: {
          title: 'Ayuda / contacto',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'ayuda/preguntas-frecuentes',
        loadComponent: () =>
          import('./pages/ayuda-contacto/preguntas-frecuentes/preguntas-frecuentes-page.component').then(
            (module) => module.PreguntasFrecuentesPageComponent
          ),
        data: {
          title: 'Preguntas frecuentes',
          eyebrow: 'Configuración',
        },
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-page.component').then(
            (module) => module.DashboardPageComponent
          ),
        data: {
          title: '',
          eyebrow: '',
        },
      },
    ],
  },
];
